
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[...url_path]",
      function () {
        return require("private-next-pages/c/[...url_path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[...url_path]"])
      });
    }
  